/* eslint-disable @typescript-eslint/no-unused-vars */

import React from 'react';
import {
  ExchangeOnlinePolicyItem,
  TabsEnum,
} from 'src/pages/Policy/utils/types';

import AdvancedSpamProtection from './AdvancedSpamProtection';
import FileBlocking from './FileBlocking';
import General from './General';
import MalwareScanning from './MalwareScanning';
import VirtualAnalyzer from './VirtualAnalyzer';
import WebReputation from './WebReputation';
import { PolicyProvider } from '@Policy/store';
import { AtpPolicy } from '../../Components/AtpPolicyEntry';
import RiskAi from './RiskAi';

const allTabs = [
  TabsEnum.general,
  TabsEnum.advancedSpamProtection,
  TabsEnum.malwareScanning,
  TabsEnum.fileBlocking,
  TabsEnum.webReputation,
  TabsEnum.virtualAnalyzer,
  TabsEnum.riskAi,
];

const allTabPanels = [
  General,
  AdvancedSpamProtection,
  MalwareScanning,
  FileBlocking,
  WebReputation,
  VirtualAnalyzer,
  RiskAi,
];

export default React.memo(function GmailAtpWithStore(props: {
  template: ExchangeOnlinePolicyItem;
  config: any;
  orgId: string;
}) {
  return (
    <PolicyProvider
      template={props.template}
      config={props.config}
      orgId={props.orgId}
    >
      <AtpPolicy tabs={allTabs} tabPanels={allTabPanels} />
    </PolicyProvider>
  );
});
